// @flow

const createSet = (at1x: string, at2x: string, at3x: string) =>
  `${at1x} 1x, ${at2x} 2x, ${at3x} 3x`

export default createSet



// WEBPACK FOOTER //
// ./src/helpers/create-set.js